import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private _authService: AuthService) { }

  canActivate() {
    return this._authService.loggedInUser$.pipe(map(user => !!user));
  }
}
